module.exports = __webpack_public_path__ + "static/media/icon-search.ebd24296.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icon-search.svg
// module id = 50
// module chunks = 0